import { Service } from '@tino-frontend/adapters'
import { FeatureFlagResponse } from '@types'

export class FeatureFlagService {
  constructor(private readonly http: Service) {
    this.http = http
  }

  getAllByCurrentCompany(companyId: string): Promise<FeatureFlagResponse> {
    return this.http.get(`/feature-flags/*/companies/${companyId}`)
  }
}
